var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('vue-terminal',{attrs:{"title":_vm.title,"prompt":_vm.prompt,"task-list":_vm.taskList,"defaultTask":_vm.defaultTask,"command-list":_vm.commandList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }